import { default as CompactTable } from './CompactTable';

export * from './CompactTableProps';
export * from './CompactTable';
export default CompactTable;
